import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  href?: string;
}
export function CTAButton({
  children,
  variant = 'primary',
  href = 'https://try.cocunat.com/cbf-op3'
}: CTAButtonProps) {
  const baseClasses = 'block w-full py-4 px-8 rounded-lg font-bold text-lg transition-all duration-200 cursor-pointer text-center';
  const variantClasses = variant === 'primary' ? 'bg-green-500 hover:bg-green-600 text-white shadow-lg hover:shadow-xl' : 'bg-pink-500 hover:bg-pink-600 text-white shadow-lg hover:shadow-xl';
  return <a href={href} className={`${baseClasses} ${variantClasses}`} data-id="element-326">
      {children}
    </a>;
}